import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldName } from '@dhl/receiver-address-format-api'
import { assertNever } from '@dhl/utils'

type Props = {
  fieldName: FieldName
}

export const AddressLabel: FC<Props> = ({ fieldName }) => {
  const { t } = useTranslation()

  switch (fieldName) {
    case 'PostalCode':
      return t('components.addressInput.postalCodeLabel')
    case 'HouseNumber':
      return t('components.addressInput.houseNumberLabel')
    case 'HouseNumberSuffix':
      return t('components.addressInput.houseNumberSuffixLabel')
    case 'Street':
      return t('components.addressInput.streetLabel')
    case 'City':
      return t('components.addressInput.cityLabel')
    case 'Suburb':
      return t('components.addressInput.suburbLabel')
    case 'AdditionalAddressLine':
      return t('components.addressInput.additionalAddressLine')
    default:
      return assertNever(fieldName)
  }
}
